import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function useZoomHandler() {
  const location = useLocation();
  const {  isAuthenticated } = useAuth();
  useEffect(() => {
    const applyZoom = () => {
      // When on the homepage ("/") and we're mounting, force a reload the very first time
      if (location.pathname === "/" && window.performance) {
        const navEntries = performance.getEntriesByType("navigation");
        // Only reload if it's not a reload navigation
        // If not a reload/refresh - and first landing on homepage, force a reload
        if (
          navEntries.length > 0 &&
          navEntries[0].type !== "reload" &&
          !window.__searchcasa_homepage_reloaded
        ) {
          window.__searchcasa_homepage_reloaded = true;
          window.location.reload();
          return; // Stop further zoom logic for this render
        }
      }
      // Apply consistent zoom across all pages based on screen size
      const screenWidth = window.innerWidth;

      const authPaths = ["/auth/login", "/auth/forgot-password", "/reset-password"];
      const isAuthPath = authPaths.includes(location.pathname);
      const isHomepageUnauthenticated = location.pathname === "/" && !isAuthenticated;

      // Auth screens and homepage before login use 100% zoom
      if (isAuthPath || isHomepageUnauthenticated) {
        document.body.style.zoom = "100%";
      } else if (screenWidth >= 1024 && screenWidth <= 1920) {
        // laptops and standard desktop monitors (12–24 inch) - 80% zoom for all pages to fit content in one screen
        document.body.style.zoom = "80%";
      } else {
        // mobiles, tablets, large monitors (>1920px) - 100% zoom
        document.body.style.zoom = "100%";
      }
    };

    applyZoom();
    window.addEventListener("resize", applyZoom);

    return () => window.removeEventListener("resize", applyZoom);
  }, [location, isAuthenticated]);
}

export default useZoomHandler;
